import React from "react";
import { Chip, CircularProgress, Paper, Typography } from "@mui/material";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";

// eslint-disable-next-line react-refresh/only-export-components
export const statusChip = (status: string) => {
  if (status === "passed") return <Chip label="Passed" size="small" color="success" />;
  if (status === "failed") return <Chip label="Failed" size="small" color="error" />;
  if (status === "cancelled") return <Chip label="Cancelled" size="small" color="default" />;
  if (status === "running") return <Chip label="Running" size="small" color="info" icon={<CircularProgress size={12} color="inherit" />} />;
  return <Chip label="Error" size="small" color="warning" />;
};

// eslint-disable-next-line react-refresh/only-export-components
export const suiteCell = (suites?: Array<{ pattern: string; suiteName: string; total: number; passed: number; failed: number }>) => {
  if (!suites?.length) return <Typography variant="caption" color="text.secondary">—</Typography>;
  const passed = suites.reduce((sum, s) => sum + s.passed, 0);
  const total = suites.reduce((sum, s) => sum + s.total, 0);
  const failed = suites.reduce((sum, s) => sum + s.failed, 0);
  const color = failed > 0 ? "#ef4444" : "#22c55e";
  return <Typography variant="caption" sx={{ color, fontWeight: 600 }}>{passed}/{total}</Typography>;
};

// eslint-disable-next-line react-refresh/only-export-components
export const statusIcon = (status: "idle" | "running" | "passed" | "failed" | "skipped") => {
  if (status === "passed") return <CheckCircleOutlineIcon sx={{ color: "#22c55e", fontSize: 18 }} />;
  if (status === "failed") return <ErrorOutlineIcon sx={{ color: "#ef4444", fontSize: 18 }} />;
  if (status === "running") return <CircularProgress size={14} />;
  return <RemoveCircleOutlineIcon sx={{ color: "#94a3b8", fontSize: 18 }} />;
};

export const SummaryCard: React.FC<{ label: string; value: string | number; color?: string }> = ({ label, value, color }) => (
  <Paper variant="outlined" sx={{ p: 2, flex: 1, minWidth: 100, textAlign: "center", borderRadius: 2 }}>
    <Typography variant="h5" fontWeight={700} sx={{ color: color ?? "text.primary" }}>{value}</Typography>
    <Typography variant="caption" color="text.secondary">{label}</Typography>
  </Paper>
);
